<template>
  <div class="main-container exam-freedom-rule">
    <div class="bread">
      <ExamIndexBread></ExamIndexBread>
      <span class="slash">/</span>
      <span class="current">自由组卷</span>
    </div>
    <div class="intro-wrap">
      <img class="icon" src="@/assets/images/exam/icon-freedom-rule-intro.png" />
      <span>根据个人需求自定义题目来源、题型与题量，生成试卷并进行练习</span>
    </div>
    <div class="rule-wrap">
      <el-form ref="form" :model="form" :rules="rules" label-width="190px" label-position="left">
        <el-form-item label="1、请输入试卷名称" prop="title">
          <el-input
            v-model="form.title"
            style="width: 488px"
            placeholder="不超过20个字"
            :maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="2、请选择优先题目来源">
          <ul class="source-wrap">
            <li
              v-for="item in sourceOptions"
              :key="item.id"
              class="source-item"
              :class="{ actived: item.id == form.source }"
              @click="onSelectSource(item.id)"
            >
              <p class="title">{{ item.title }}</p>
              <p class="desc">{{ item.desc }}</p>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="3、请设置答题时间" prop="time">
          <el-input-number
            v-model="form.time"
            style="width: 96px"
            :min="0"
            :max="180"
            :precision="0"
            :controls="false"
          ></el-input-number>
          <span class="common-unit">分钟</span>
          <p class="common-note">只能填写整数，不能超过180分钟</p>
        </el-form-item>
        <el-form-item label="4、请选择题型与题量" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">随机不限</el-radio>
            <el-radio :label="2">自定义题量</el-radio>
            <el-radio :label="3">自定义题型与题量</el-radio>
          </el-radio-group>
          <div v-show="form.type == 1" class="type1-wrap">
            <i class="icon el-icon-warning-outline"></i>
            <span class="desc"> 从整个题库中选择{{ questionInfo.count }}道题 </span>
          </div>
          <div v-show="form.type == 2" class="type2-wrap">
            <el-input-number
              v-model="questionNum"
              style="width: 96px"
              :min="0"
              :max="Math.min(200, questionInfoTotalNumber)"
              :precision="0"
              :controls="false"
            ></el-input-number>
            <span class="common-unit">题</span>
            <p class="common-note">
              只能填写整数，最多不超过200道题，当前题库共计{{ questionInfoTotalNumber }}道题
            </p>
          </div>
          <div v-show="form.type == 3" class="type3-wrap">
            <el-checkbox-group v-model="questionOptionSelect" class="question-option-wrap">
              <div v-for="item in questionOptions" :key="item.key" class="question-option-item">
                <el-checkbox :label="item.key" style="vertical-align: top">
                  {{ item.title }}
                </el-checkbox>
                <div style="display: inline-block">
                  <el-input-number
                    v-model="item.num"
                    style="width: 96px"
                    :min="0"
                    :max="questionInfo.question_count_detail[item.key]"
                    :precision="0"
                    :controls="false"
                  ></el-input-number>
                  <span class="common-unit">题</span>
                  <p class="common-note">
                    只能填写整数，当前题库共计{{
                      questionInfo.question_count_detail[item.key] || 0
                    }}道{{ item.title }}
                  </p>
                </div>
              </div>
            </el-checkbox-group>
            <div>
              <span>总计：{{ quesionOptionSelectTotalNumber }}题</span>
              <span class="common-note ml">最多不超过200道题</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="buttom-wrap">
          <el-checkbox v-model="form.is_remember" :true-label="1" :false-label="2">
            记住我的选择，下次考试时不用选择
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="onSubmit"> 开始考试 </el-button>
          <el-button size="medium" @click="$router.back()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import ExamIndexBread from './components/ExamIndexBread.vue';
export default {
  name: 'ExamFreedomRule',
  components: { ExamIndexBread },
  data() {
    const validatorTitle = (rule, value, callback) => {
      if (!value.trim()) {
        return callback(new Error('请填写试卷名称'));
      }
      callback();
    };
    const validatorTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请填写正确的答题时间'));
      }
      callback();
    };
    const validatorType = (rule, value, callback) => {
      switch (+value) {
        case 2:
          if (!this.questionNum) {
            return callback(new Error('请填写正确的题量'));
          }
          break;
        case 3:
          if (!this.questionOptionSelect.length) {
            return callback(new Error('请选择题型'));
          }
          for (const item of this.questionOptions) {
            if (this.questionOptionSelect.includes(item.key) && !item.num) {
              return callback(new Error('请填写正确的题量'));
            }
          }
          break;
      }
      callback();
    };
    return {
      attr_val_id: this.$route.query.attr_val_id,
      use_rule: this.$route.query.use_rule,
      form: {
        title: '',
        source: 1,
        time: undefined,
        type: 1,
        is_remember: 2,
      },
      rules: {
        title: [{ validator: validatorTitle }],
        time: [{ validator: validatorTime }],
        type: [{ validator: validatorType }],
      },
      questionNum: undefined,
      questionOptionSelect: [],
      questionInfo: {
        count: 0,
        question_count_detail: {},
      },
      sourceOptions: [
        { id: 1, title: '错题', desc: '优先选择错题为题目来源' },
        { id: 2, title: '未做过的题', desc: '优先选择未做过的题为题目来源' },
        { id: 3, title: '不限', desc: '从整个题库中选择' },
      ],
      questionOptions: [
        { key: 'signalChoice', title: '单选题', num: undefined },
        { key: 'multiChoice', title: '多选题', num: undefined },
        { key: 'judge', title: '判断题', num: undefined },
        { key: 'blank', title: '填空题', num: undefined },
        { key: 'shortAnswer', title: '简单题', num: undefined },
        { key: 'material', title: '材料题', num: undefined },
      ],
    };
  },
  computed: {
    // 自定义题型与题量   用户选择的总量
    quesionOptionSelectTotalNumber() {
      let ret = 0;
      this.questionOptions.forEach((option) => {
        if (this.questionOptionSelect.includes(option.key)) {
          ret += option.num || 0;
        }
      });
      return ret;
    },
    // 自定义题量  提示语中的题目数量
    questionInfoTotalNumber() {
      let ret = 0;
      for (const key in this.questionInfo.question_count_detail) {
        ret += this.questionInfo.question_count_detail[key] || 0;
      }
      return ret;
    },
  },
  watch: {
    'form.source'(val) {
      this.clearQuestionFormData();
      this.requestQuestionInfo(val);
    },
  },
  created() {
    if (this.use_rule) {
      this.requestLastRule();
    } else {
      this.requestQuestionInfo(this.form.source);
    }
  },
  methods: {
    // on event
    onSelectSource(sourceId) {
      this.form.source = sourceId;
    },
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          this.$error('请完善信息');
          return;
        }
        const params = { ...this.form };
        if (params.type == 2) {
          params.question_num = this.questionNum;
        } else if (params.type == 3) {
          const countObj = {};
          this.questionOptions.forEach((option) => {
            if (this.questionOptionSelect.includes(option.key)) {
              countObj[option.key] = option.num;
            }
          });
          params.question_custom = JSON.stringify(countObj);
        }
        const ruleId = await this.$http.post('/api/app/freedom/add', params);
        const reportId = await this.$http.post('/api/app/practice/report', {
          type: 6,
          attr_val_id: this.attr_val_id,
          freedom_rule_id: ruleId,
        });
        if (reportId.length === 0) {
          this.$info('当前没有题目可以练习');
          return;
        }
        this.$router.push({
          name: 'ExamFreedomDo',
          query: {
            id: reportId,
            examType: '自由组卷',
          },
        });
      });
    },
    // 清空题目表单信息
    clearQuestionFormData() {
      this.questionNum = undefined;
      this.questionOptionSelect = [];
      this.questionOptions.forEach((option) => {
        option.num = undefined;
      });
    },
    // request
    // 请求题量信息
    async requestQuestionInfo(source) {
      const data = await this.$http.get('/api/app/freedom/getQuestionInfo', {
        source,
        attr_val_id: this.attr_val_id,
      });
      this.questionInfo = data;
    },
    // 请求上次规则
    async requestLastRule() {
      const data = await this.$http.get('/api/app/freedom/getLastFreedRule');
      this.form.source = data.source;
      await this.requestQuestionInfo(data.source);
      this.form.time = parseInt(data.time / 60);
      this.form.type = data.type;
      this.form.is_remember = data.is_remember;
      if (data.type == 2) {
        this.questionNum = data.question_num;
      } else if (data.type == 3) {
        for (const key in data.question_custom) {
          // 填充选择
          this.questionOptionSelect.push(key);
          // 填充数量
          this.questionOptions.forEach((option) => {
            if (option.key == key) {
              option.num = +data.question_custom[key];
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-radio__input.is-checked + .el-radio__label,
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333;
  }
  .el-form-item__label {
    color: #666;
  }
}

.exam-freedom-rule {
  font-size: 14px;
  color: #333;
}
.intro-wrap {
  height: 85px;
  background-color: #fff;
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  .icon {
    width: 45px;
    margin-right: 16px;
  }
}
.rule-wrap {
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
}
.source-wrap {
  display: flex;
  .source-item {
    width: 234px;
    height: 108px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
    cursor: pointer;
    .title {
      font-size: 16px;
      font-weight: 600;
    }
    .desc {
      color: #666;
    }
    &.actived {
      border-color: #ff5b24;
      background-color: rgba(252, 86, 35, 0.04);
    }
  }
}
.common-unit {
  color: #666;
  margin-left: 12px;
}
.common-note {
  color: #ccc;
  &.ml {
    margin-left: 12px;
  }
}
.type1-wrap {
  color: #999;
  display: flex;
  align-items: center;
  margin-top: 10px;
  .icon {
    font-size: 18px;
    margin-right: 8px;
  }
}
.type2-wrap {
  margin-top: 15px;
}
.type3-wrap {
  margin-top: 20px;
}
.question-option-wrap {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  .question-option-item {
    margin-bottom: 10px;
  }
}
.buttom-wrap {
  border-top: 1px solid #e8e8e8;
  padding-top: 20px;
  ::v-deep .el-checkbox__label {
    color: #666 !important;
  }
}
</style>
